import type { PromotionRequest, PromotionRequestOpening } from 'store/reducers/promotionRequestReducer';
import type { Office } from 'store/reducers/types';

/* Openings ordered by `opening_order` (prior opening first), falling back to API order. */
export const orderedOpenings = (request: PromotionRequest): PromotionRequestOpening[] => {
  const byId = new Map(request.openings.map(opening => [opening.uuid, opening]));
  const order = request.opening_order?.length ? request.opening_order : request.openings.map(opening => opening.uuid);
  return order.map(uuid => byId.get(uuid)).filter((opening): opening is PromotionRequestOpening => !!opening);
};

export const formatOfficeList = (offices: Office[] = []): string =>
  offices.map(office => (office.company ? `${office.company.name} – ${office.name}` : office.name)).join('; ');

export const openingLabel = (opening: PromotionRequestOpening): string =>
  opening.title || opening.custom_level || opening.level;
